import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(function (config) {
  // store auth time
  localStorage.setItem("authTime", Date.now().toString());

  // get adminInfo (Bearer token)
  let adminInfo = null;
  if (localStorage.getItem("adminInfo")) {
    adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  }

  // get authkey (access token)
  const authKey = localStorage.getItem("authkey");

  // get company
  const company = Cookies.get("company");

  // 🔍 console logs (for verification)
  // console.log("adminInfo token:", adminInfo?.token);
  // console.log("authkey:", authKey);

  // set headers
  if (adminInfo?.token) {
    config.headers.authorization = `Bearer ${adminInfo.token}`;
  }

  if (authKey) {
    config.headers.accesstoken = authKey;
  }

  if (company) {
    config.headers.company = company;
  }

  // 🔍 final headers log
  // console.log("Final Request Headers:", config.headers);

  return config;
});

const responseBody = (response) => response.data;

const requests = {

  
  get: (url, body, headers) =>
    
    instance.get(url, body, headers).then(responseBody),

  post: (url, body) => instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url, body) => instance.delete(url, body).then(responseBody),
};

export default requests;
